module.exports = __webpack_public_path__ + "static/media/copy.cfe02097.svg";